/* dcl-garmin-offer.js  (rev 3)
 * Dialed Cycling Lab. Delivers the Garmin offer code DC-Garmin26.
 *
 * rev 2 (2026-09-30): heading and body copy changed at Jake's request.
 * rev 3 (2026-10-03): (a) the card no longer shows to a shopper who already
 *   has DC-Garmin26 applied (Shopify's discount_code cookie). (b) New block at
 *   the end of this file: once the code is applied, the product page shows
 *   "Your price" under the regular price. Jake's call: only the shopper who
 *   applied the code ever sees it; crawlers and Google Shopping see list price.
 * rev 3.1 (2026-10-03): card copy and button now point to the on-page price.
 *
 * Built 2026-09-16 from dcl-silca-offer.js rev 2, with two deliberate
 * differences:
 *
 *   1. NO GIFT CARD. Jake passed on the $20 card for Garmin for now, so this
 *      card has one perk, the discount. If a gift card is added later (he
 *      raised it as a pairing for a Google campaign), it needs the Silca
 *      pattern in full: a note file, a cart file, a terms page, and a Flow.
 *
 *   2. THE DISCOUNT AMOUNT IS NEVER PRINTED. This follows the Lake rule, not
 *      the Silca one. Garmin enforces MAP harder than Silca, so the number
 *      lives only in the Shopify discount and lands in the shopper's cart.
 *      Neither the percentage nor the code string appears as page text; the
 *      code is only ever inside the /discount/ URL the button navigates to.
 *      Do not add the number to the copy without asking Jake.
 *
 * THE HUMANITY GATE stays. A real pointermove, touchstart, keydown or wheel
 * must happen before any trigger counts, so a crawler or MAP monitor that
 * does not execute JavaScript never sees the card at all.
 *
 * STORAGE. seenKey is sessionStorage: the card shows once per visit. savedKey
 * is localStorage: a saved deal survives the shopper closing the tab and
 * coming back later.
 *
 * MASTER SWITCH. theme.liquid only emits this script when the shop metafield
 * dcl.garmin_offer_enabled is not false. Turning the offer off for a sale
 * also means deactivating DC-Garmin26 in Discounts.
 */
(function () {
  'use strict';

  if (window.__dclGarminOffer) return;
  window.__dclGarminOffer = true;
  if (!window.DCL_GARMIN_OFFER_ELIGIBLE) return;
  if (navigator.webdriver) return;

  var CFG = {
    code: 'DC-Garmin26',
    armDelayMs: 1500,
    dwellMs: 3000,
    scrollPct: 0.25,
    seenKey: 'dcl_garmin_offer_seen',
    savedKey: 'dcl_garmin_offer_saved'
  };

  var armed = false;
  var human = false;
  var shown = false;
  var dwellDone = false;

  function readSession(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function readLocal(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function writeLocal(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function clearLocal(key) {
    try { localStorage.removeItem(key); } catch (e) { /* private mode */ }
  }

  function seen() { return readSession(CFG.seenKey) === '1'; }
  function codeApplied() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === CFG.code.toUpperCase(); } catch (e) { return false; }
  }
  function saved() { return readLocal(CFG.savedKey) === '1'; }

  function svgMark(paths) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '21');
    svg.setAttribute('height', '21');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function tagIcon() {
    return svgMark([
      'M20.59 13.41l-7.17 7.17a2 2 0 0 1 -2.83 0l-7.17 -7.17a2 2 0 0 1 -.59 -1.41v-5a2 2 0 0 1 2 -2h5a2 2 0 0 1 1.41 .59l9.35 9.35',
      'M7 7l.01 0'
    ]);
  }

  function perk(icon, buildCopy) {
    var row = document.createElement('div');
    row.className = 'dcl-go-perk';
    var mark = document.createElement('span');
    mark.className = 'dcl-go-mark';
    mark.appendChild(icon);
    row.appendChild(mark);
    var copy = document.createElement('span');
    copy.className = 'dcl-go-copy';
    buildCopy(copy);
    row.appendChild(copy);
    return row;
  }

  function bold(text) {
    var b = document.createElement('span');
    b.className = 'dcl-go-strong';
    b.textContent = text;
    return b;
  }

  /* The amount is deliberately absent. See the file header. */
  function discountCopy(el) {
    el.appendChild(document.createTextNode('Hit the button below to unlock your special price, right on the product page.'));
  }

  function apply() {
    /*
     * Shopify's /discount/CODE route applies the code to the cart session and
     * then redirects. Sending them back where they were keeps the shopping flow
     * intact. Clear the saved flag first, so the recall tab does not follow
     * them around after they have taken it.
     */
    clearLocal(CFG.savedKey);
    var back = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(CFG.code) +
      '?redirect=' + encodeURIComponent(back);
  }

  function fade(node) {
    node.classList.remove('is-open');
    setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, 250);
  }

  function showTab() {
    if (document.querySelector('.dcl-go-tab')) return;

    var tab = document.createElement('div');
    tab.className = 'dcl-go-tab';

    var go = document.createElement('button');
    go.className = 'dcl-go-tab__go';
    go.type = 'button';
    go.appendChild(document.createTextNode('Your deal is saved'));
    var sub = document.createElement('span');
    sub.textContent = 'Tap to apply it';
    go.appendChild(sub);

    var x = document.createElement('button');
    x.className = 'dcl-go-tab__x';
    x.type = 'button';
    x.setAttribute('aria-label', 'Dismiss saved deal');
    x.textContent = '\u00d7';

    tab.appendChild(go);
    tab.appendChild(x);
    document.body.appendChild(tab);
    requestAnimationFrame(function () { tab.classList.add('is-open'); });

    go.addEventListener('click', apply);
    x.addEventListener('click', function () {
      clearLocal(CFG.savedKey);
      fade(tab);
    });
  }

  function save(wrap) {
    writeLocal(CFG.savedKey, '1');
    fade(wrap);
    setTimeout(showTab, 260);
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'dcl-go-wrap';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Garmin offer');

    var card = document.createElement('div');
    card.className = 'dcl-go-card';

    var x = document.createElement('button');
    x.className = 'dcl-go-close';
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.textContent = '\u00d7';
    card.appendChild(x);

    var eyebrow = document.createElement('div');
    eyebrow.className = 'dcl-go-eyebrow';
    eyebrow.textContent = 'Just for You!';
    card.appendChild(eyebrow);

    var perks = document.createElement('div');
    perks.className = 'dcl-go-perks';
    perks.appendChild(perk(tagIcon(), discountCopy));
    card.appendChild(perks);

    var go = document.createElement('button');
    go.className = 'dcl-go-go';
    go.type = 'button';
    go.textContent = 'Show my price';
    card.appendChild(go);

    var later = document.createElement('button');
    later.className = 'dcl-go-skip';
    later.type = 'button';
    later.textContent = 'Save it for later';
    card.appendChild(later);

    wrap.appendChild(card);

    /*
     * Four ways out so the card can never trap a shopper. All three of the
     * non-apply routes save the deal rather than discard it, because a shopper
     * who closes the card is not saying no, they are saying not now, and the
     * card will not fire again this session.
     */
    go.addEventListener('click', apply);
    later.addEventListener('click', function () { save(wrap); });
    x.addEventListener('click', function () { save(wrap); });
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) save(wrap);
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key !== 'Escape') return;
      document.removeEventListener('keydown', esc);
      if (wrap.parentNode) save(wrap);
    });

    return wrap;
  }

  function show(reason) {
    if (shown || seen()) return;
    shown = true;
    writeSession(CFG.seenKey, '1');
    var wrap = build();
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({ event: 'dcl_garmin_offer_shown', trigger: reason });
    }
  }

  function scrolledPast() {
    var doc = document.documentElement;
    var height = doc.scrollHeight - window.innerHeight;
    if (height <= 0) return false;
    return (window.scrollY || doc.scrollTop) / height >= CFG.scrollPct;
  }

  function maybeShow(reason) {
    if (!armed || !human) return;
    show(reason);
  }

  /* 2026-09-25: timing cut to 1.5s arm, 3s dwell, 25% scroll so the card
     lands before a shopper clicks away. If the dwell mark passes before the
     first real interaction, the card now shows on that interaction instead
     of waiting for a scroll that may never come. */
  function onHuman() {
    human = true;
    if (dwellDone) maybeShow('dwell-late');
  }

  function start() {
    /* rev 3: the deal is already in their cart, so do not pitch it again. */
    if (codeApplied()) { clearLocal(CFG.savedKey); return; }

    /* A saved deal outranks the card. Show the tab and stop, so a returning
       shopper gets their deal back rather than the same pitch again. */
    if (saved()) {
      showTab();
      return;
    }

    if (seen()) return;

    ['pointermove', 'touchstart', 'keydown', 'wheel'].forEach(function (evt) {
      window.addEventListener(evt, onHuman, { once: true, passive: true });
    });

    setTimeout(function () {
      armed = true;
      if (scrolledPast()) maybeShow('scroll-armed');
    }, CFG.armDelayMs);

    setTimeout(function () { dwellDone = true; maybeShow('dwell'); }, CFG.dwellMs);

    window.addEventListener('scroll', function () {
      if (scrolledPast()) maybeShow('scroll');
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* YOUR PRICE (rev 3, 2026-10-03)
 * Shows the shopper their discounted price on the product page after they
 * apply DC-Garmin26. Conditions, all required:
 *   - window.DCL_GARMIN_OFFER_IN_SCOPE (theme.liquid mirrors the rules of the
 *     "Garmin - Discount Eligible (Full Price)" collection the code is scoped to)
 *   - window.DCL_GARMIN_OFFER_PCT between 1 and 99 (shop metafield
 *     dcl.garmin_offer_pct; KEEP IT EQUAL TO THE DC-Garmin26 PERCENTAGE)
 *   - Shopify's discount_code cookie equals DC-Garmin26
 *   - the selected variant is not marked down (compare_at_price <= price),
 *     because the code skips reduced-price items
 * Math matches Shopify's line discount: price minus floor(price * pct / 100)
 * in cents (Shopify rounds the discount down; verified in cart). The theme re-renders the price block on variant change; a
 * MutationObserver re-applies this after each re-render. */
(function () {
  'use strict';
  if (window.__dclGarminYourPrice) return;
  window.__dclGarminYourPrice = true;

  var CODE = 'DC-Garmin26';
  var pct = Number(window.DCL_GARMIN_OFFER_PCT) || 0;
  if (!window.DCL_GARMIN_OFFER_IN_SCOPE || !(pct > 0 && pct < 100)) return;

  function codeApplied() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === CODE.toUpperCase(); } catch (e) { return false; }
  }
  if (!codeApplied()) return;

  var path = window.location.pathname;
  var at = path.indexOf('/products/');
  if (at < 0) return;
  var handle = path.slice(at + 10).split('/')[0];
  if (!handle) return;

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var product = null;
  var pending = false;
  var lastKey = "";

  function priceBox() { return document.querySelector('[id^="price-"][id$="__main"]'); }

  function variantId() {
    var info = document.querySelector('[id^="ProductInfo-"][id$="__main"]') || document;
    var input = info.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = input && input.value;
    if (!v) v = new URLSearchParams(window.location.search).get('variant');
    return v ? Number(v) : null;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'dcl-go-yourprice';
    el.setAttribute('aria-live', 'polite');
    var label = document.createElement('span');
    label.className = 'dcl-go-yourprice__label';
    label.textContent = 'Your price';
    var amt = document.createElement('span');
    amt.className = 'dcl-go-yourprice__amt';
    var note = document.createElement('span');
    note.className = 'dcl-go-yourprice__note';
    note.textContent = "Your Garmin discount is applied. You'll see it in your cart.";
    el.appendChild(label);
    el.appendChild(amt);
    el.appendChild(note);
    return el;
  }

  function render() {
    pending = false;
    var box = priceBox();
    if (!box || !product) return;
    var id = variantId();
    var v = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) { v = product.variants[i]; break; }
    }
    if (!v) v = product.variants[0];
    lastKey = String(v.id);
    var el = document.querySelector('.dcl-go-yourprice');
    var reduced = v.compare_at_price && v.compare_at_price > v.price;
    if (reduced) {
      if (el) el.parentNode.removeChild(el);
      if (box.classList.contains('dcl-go-struck')) box.classList.remove('dcl-go-struck');
      return;
    }
    /* Shopify rounds the percentage discount DOWN to the cent (verified in cart
       2026-10-03: $1,099.99 at 10% = $109.99 off, $990.00 charged). */
    var cents = v.price - Math.floor(v.price * pct / 100);
    var text = money.format(cents / 100);
    if (!box.classList.contains('dcl-go-struck')) box.classList.add('dcl-go-struck');
    if (!el) el = build();
    if (el.previousElementSibling !== box) box.insertAdjacentElement('afterend', el);
    var amt = el.querySelector('.dcl-go-yourprice__amt');
    if (amt.textContent !== text) amt.textContent = text;
  }

  function schedule() {
    if (pending) return;
    pending = true;
    /* setTimeout, not requestAnimationFrame: rAF pauses in background tabs. */
    setTimeout(render, 30);
  }

  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      product = p;
      render();
      /* The theme redraws the price before it updates the hidden variant field,
         so re-check shortly after any change, and poll cheaply as a backstop. */
      document.addEventListener('change', function () {
        setTimeout(schedule, 60); setTimeout(schedule, 300); setTimeout(schedule, 900);
      });
      setInterval(function () {
        var id = variantId();
        var box = priceBox();
        if ((id && String(id) !== lastKey) || (box && !box.classList.contains('dcl-go-struck') && document.querySelector('.dcl-go-yourprice'))) schedule();
      }, 500);
      var host = document.querySelector('[id^="ProductInfo-"][id$="__main"]') || document.body;
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    })
    .catch(function () {});
})();
